import { render, staticRenderFns } from "./company-certify.vue?vue&type=template&id=1a700f58&scoped=true&"
import script from "./company-certify.vue?vue&type=script&lang=js&"
export * from "./company-certify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a700f58",
  null
  
)

export default component.exports